module.exports = __webpack_public_path__ + "60c4cbc412eb07cd0d32e776f3616cf7.svg";